/* eslint-disable no-restricted-globals */
function openEstimateModal(e) {
  return {
    type: 'OPEN_ESTIMATE_MODAL',
    event: e,
  };
}

function closeEstimateModal() {
  history.pushState('', document.title, window.location.pathname + window.location.search);
  return {
    type: 'CLOSE_ESTIMATE_MODAL',
  };
}
export { closeEstimateModal, openEstimateModal };
